import type { NewsSentimentType } from '@/models/marketData';

export const SentimentBadge = ({
  type,
  label,
  count,
}: {
  type: NewsSentimentType;
  label: string;
  count?: number;
}) => (
  <span className={`sentiment-chip sentiment-chip--${type}`}>
    {label}
    {count !== undefined && count > 0 && <b>{count}</b>}
  </span>
);
